import React from 'react';

type ControlledModeProps = {
  /** Progress percentage for controlled mode (0 to 100) */
  progress: number;
  mode?: 'controlled';
};

type InfiniteModeProps = {
  /** Mode can be "infinite" */
  mode: 'infinite';
};

export type HorizontalLoaderProps = (
  | ControlledModeProps
  | InfiniteModeProps
) & {
  /** Additional classes for the container */
  className?: string;
};

const HorizontalLoader: React.FC<HorizontalLoaderProps> = (props) => {
  if (props.mode === 'infinite') {
    return (
      <div
        className={`relative h-2 w-full overflow-hidden rounded-full bg-gray-200 ${props.className}`}
      >
        {/* The inner div uses a custom animation defined in Tailwind config */}
        <div className="animate-infinite-loader absolute top-0 h-full bg-blue-500" />
      </div>
    );
  }

  // Controlled mode: width is based on the progress prop with smooth transition.
  return (
    <div className={`h-2 w-full rounded-full bg-gray-200 ${props.className}`}>
      <div
        className="h-2 rounded-full bg-blue-500 transition-all duration-300"
        style={{ width: `${props.progress}%` }}
      />
    </div>
  );
};

export default HorizontalLoader;
